import { useMessages } from './i18n/context';
import { blockTypeName } from './blocks/blockTypeName';
import type { ComponentResponse } from './api/types';
import { TODO_LIST_TYPE } from './blocks/todo';
import { TodoList } from './blocks/TodoList';

/**
 * The component tree without any affordance — what a reader, a public viewer, or a caller on a
 * frozen legacy plan sees (ADR-027 §7: below Write the document is content, not a form). A
 * top-level `todo-list` shows as the checklist with its ticks, read-only (ADR-029 §3); nested
 * ones render as generic blocks, exactly as the editor treats them.
 */
export function ReadOnlyTree({
  components,
  nested = false,
}: {
  components: readonly ComponentResponse[];
  nested?: boolean;
}) {
  const t = useMessages();
  return (
    <ul className="block-tree">
      {components.map((component) =>
        !nested && component.type === TODO_LIST_TYPE ? (
          <TodoList key={component.id} list={component} busy={false} editable={false} />
        ) : (
          <li className="block-node card" key={component.id}>
            <div className="block-title">
              <strong>{component.properties['title'] ?? component.id}</strong>{' '}
              <span className="block-type">({blockTypeName(t, component.type)})</span>
            </div>
            {component.children.length > 0 && (
              <ReadOnlyTree components={component.children} nested />
            )}
          </li>
        ),
      )}
    </ul>
  );
}
